import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, map, startWith, take } from 'rxjs/operators';

@Component({
  selector: 'tcs-splash-screen',
  templateUrl: './splash-screen.component.html',
  styleUrls: ['./splash-screen.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SplashScreenComponent {
  public isLoading$: Observable<boolean>;
  constructor(router: Router) {
    this.isLoading$ = router.events.pipe(
      filter((e) => e instanceof NavigationEnd),
      take(1),
      map(() => false),
      startWith(true),
    );
  }
}
